module.exports = __webpack_public_path__ + "static/media/085-solomon-islands.69fdedb2.svg";